"use strict";

var _require = require("../formatters"),
  dateString = _require.dateString;
var moment = require("moment-timezone");
var momentParse = function momentParse(value, formatString, timezone) {
  var defaultFormats = [moment.ISO_8601];
  return moment.tz(value, [formatString].concat(defaultFormats), timezone);
};
module.exports = momentParse;